import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
export default {
  namespaced: true,
  getters: {
    RCJTJTableData: state => state.RCJTJTableData,
    DISPUTETable: state => state.DISPUTETable
  },
  state: () => ({
    RCJTJTableData: [],
    DISPUTETable: []
  }),
  mutations: {
    SAVE(state, effectData) {
      Object.entries(effectData).forEach(([k, v]) => {
        state[k] = v;
      });
      console.log(state, 'SAVE');
    }
  },
  actions: {
    /**
     * 插入 tableData 数据 （增量）
     */
    // async insetData<T = any>({ commit, state }: IArgStore, params: T) {
    //   let tableData = [...state.tableData]
    //   /* 如果入参是个数组 */
    //   if (typeof params === 'object' && Array.isArray(params)) {
    //     tableData = [...tableData, ...params]
    //   }
    //   /* 如果入参是对象 */
    //   if (
    //     typeof params === 'object' &&
    //     Object.prototype.toString.call(params) === '[object Object]'
    //   ) {
    //     tableData.push(params)
    //   }
    //   commit('SAVE', { tableData: state.tableData })
    // },
    /**
     * 全量覆盖 人材机调价 tableData 数据
     */
    async coverSetRcjtjData({
      commit
    }, params) {
      const {
        formData,
        isCover
      } = params;
      const result = [];
      if (isCover) {
        /* `费用汇总` 中 `是否切换人材机调价` 为 是 */
        formData.to_FyshFymxQdxSet.forEach((e, idx) => {
          if (e.Fytype1 === '07') {
            /* 如果 `其他清单项` 中，当前行里面的 `费用项类型` 为 `人材机调价` */
            /* 把当前行中的 IsTransfer（是否切换人材机调价）设置为 X */
            formData.to_FyshFymxQdxSet[idx].IsTransfer = 'X';
            result.push(e);
          }
        });
        commit('SAVE', {
          RCJTJTableData: result
        });
      } else {
        /* `费用汇总` 中 `是否切换人材机调价` 为 否 */
        formData.to_FyshFymxQdxSet.forEach((e, idx) => {
          formData.to_FyshFymxQdxSet[idx].IsTransfer = '';
        });
        commit('SAVE', {
          RCJTJTableData: []
        });
      }
      /* 返回数据，赋值到 pageObjInj.formData.to_FyshFymxTjSet 里 */
      return result;
    },
    /**
     * 全量覆盖 费用争议 表格数据
     * 返回 费用争议(to_FyshFyzySet)表格数据
     */
    async coverSetDISPUTEData({
      commit
    }, formData) {
      /* 从费用明细下的 7 个表格带出， */
      /* `费用明细` 下的 7 个 tabs 对应的表名称 */
      const handleArrName = ['to_FyshFymxRySet', 'to_FyshFymxClSet', 'to_FyshFymxJxSet', 'to_FyshFymxLsSet', 'to_FyshFymxQtSet', 'to_FyshFymxQdxSet', 'to_FyshFymxTjSet' // 人材机调价
      ];
      const result = handleArrName.reduce((acc, cur) => {
        formData[cur].forEach(t => {
          if (t.IsConflict && t.IsConflict === 'X') {
            acc.push(t);
          }
        });
        return acc;
      }, []);
      commit('SAVE', {
        DISPUTETable: result
      });
      return result;
    }
  }
};